import { GrcNotify, NotifyType } from '@grc/ui-package';
import notify from '../../common/notify';
import { transportationService } from '../../common/constants/constants';
import { transportsUrl } from '../../common/constants/url-constants';

// Full transport record (legs, carrier, stops) - GetTransportNumberById
// (get-transport-number-by-id.ts) only returns the display number, which
// isn't enough to derive the carrier/stops the tracking drawer needs.
export const GetTransportById = async (
  transportId: string,
  fetchData: any
): Promise<any | undefined> => {
  if (!transportId) return undefined;

  try {
    const response = await fetchData(
      `${transportsUrl}/${transportId}`,
      notify,
      transportationService
    );

    if (response?.status !== 200) return undefined;

    return response.data?.[0] ?? response.data;
  } catch (error: any) {
    GrcNotify({
      message: error.message,
      status: NotifyType.Error
    });
    return undefined;
  }
};

export default GetTransportById;
